import React from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';

import { useNavigate } from 'react-router-dom';

// assets
import { LockOutlined, QuestionCircleOutlined, UserOutlined } from '@ant-design/icons';

// ==============================|| HEADER PROFILE - SETTING TAB ||============================== //

const SettingTab = () => {
	const theme = useTheme();
	const navigate = useNavigate();

	return (
		<List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32, color: theme.palette.grey[500] } }}>
			<ListItemButton onClick={() => navigate('/attendance')}>
				<ListItemIcon>
					<UserOutlined />
				</ListItemIcon>
				<ListItemText primary="Attendance" />
			</ListItemButton>
			<ListItemButton>
				<ListItemIcon>
					<LockOutlined />
				</ListItemIcon>
				<ListItemText primary="Privacy Center" />
			</ListItemButton>
			<ListItemButton>
				<ListItemIcon>
					<QuestionCircleOutlined />
				</ListItemIcon>
				<ListItemText primary="Support" />
			</ListItemButton>
		</List>
	);
};

export default SettingTab;
